import { StyleSheet } from 'react-native-unistyles';
import { useChatDetailContext } from '@/components/Chat/ChatDetailContext';
import ChatMessageEmojiInput from '@/components/Chat/ChatMessageEmojiInput';
import { ChatMessageEmojiInputFragment } from '@/components/Chat/ChatMessageEmojiInput.utils';
import Card from '@/components/UI/Card';
import Icon from '@/components/Unistyles/Icon';
import Pressable from '@/components/Unistyles/Pressable';
import { type FragmentOf, readFragment } from '@/gql/graphql';

const emojis = ['❤️', '👍', '👎', '❓', '😂'];

export default function ChatMessageItemMenu({
  fragment,
}: {
  fragment: FragmentOf<typeof ChatMessageEmojiInputFragment>;
}) {
  const message = readFragment(ChatMessageEmojiInputFragment, fragment);
  const detailSheetRef = useChatDetailContext((state) => state.detailSheetRef);
  const inputRef = useChatDetailContext((state) => state.inputRef);
  const setContext = useChatDetailContext((state) => state.setContext);

  return (
    <Card style={style.container}>
      {emojis.map((emoji) => {
        return (
          <ChatMessageEmojiInput
            key={emoji}
            emoji={emoji}
            fragment={fragment}
            showCount={false}
            variant="borderless"
            size="2xl"
          />
        );
      })}
      <Pressable
        accessibilityLabel="Message actions"
        style={style.button}
        onPress={() => {
          inputRef?.current?.blur();
          setContext({ selectedMessageId: message.id });
          detailSheetRef?.current?.present();
        }}
        testID="ChatMessageActionsButton"
      >
        <Icon size="2xl" name="ellipsis-vertical" />
      </Pressable>
    </Card>
  );
}

const style = StyleSheet.create((theme) => ({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    position: 'absolute',
    right: theme.space('xl'),
    top: -theme.space(5),
    borderRadius: theme.borderRadius['2xl'],
    overflow: 'hidden',
    backgroundColor: theme.colors.backgroundMuted,
    zIndex: 999,
    flex: 1,
  },
  button: {
    flex: 1,
    alignSelf: 'stretch',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: theme.space('lg'),
    borderWidth: 0,
    borderRadius: theme.borderRadius.none,
    _web: {
      _hover: {
        backgroundColor: theme.colors.secondaryHover,
      },
    },
  },
}));
